


export default {

    props: ['instance','homePageCardImage','strapiBaseUri'],
}
